import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppComponent } from './app.component';

import { HeaderComponent } from './components/template/header/header.component';
import { FooterComponent } from './components/template/footer/footer.component';
import { Page401Component } from './components/page-error/page401/page401.component';
import { Page404Component } from './components/page-error/page404/page404.component';
import { PageLoginComponent } from './components/page/page-login/page-login.component';

import { PageLogoutComponent } from './components/page/page-logout/page-logout.component';
import { PageDashboardComponent } from './components/page/page-dashboard/page-dashboard.component';
import { AppRoutingModule } from './app-routing.module';
import { CamelCaseFormat } from './components/core/camelCasePipe';
import { DataService} from "./data.service";
import { GuardComponent } from './components/core/security/guard/guard.component';
import { DataTablesModule } from "angular-datatables";
import { FilterComponent } from './components/widgets/filter/filter.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    Page401Component,
    Page404Component,
    PageLoginComponent,
    PageDashboardComponent,
    PageLogoutComponent,
    CamelCaseFormat,
    GuardComponent,
    FilterComponent
  ],
  imports: [BrowserModule, AppRoutingModule, DataTablesModule],
  providers: [DataService, GuardComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
